<!-- @format -->

<div class="plp-srlp-compare-thumbnail hmf-pt-xs hmf-pr-xs hmf-position-relative">
	<img
		class="compare-thumbnail-image"
		title="Compare thumbnail {{ compareData()?.name }}"
		[src]="compareData()?.imgURL"
		[alt]="compareData()?.name" />
	<button
		hmf-button
		class="compare-remove-button hmf-position-absolute hmf-p-xxs"
		title="Remove {{ compareData()?.name }} from Comparison Bar"
		label="Remove {{ compareData()?.name }} from Comparison Bar"
		[variant]="'secondary'"
		(click)="onRemove()">
		<homefield-icon
			name="sign-cancel"
			width="16"
			height="16"></homefield-icon>
	</button>
</div>
